document.addEventListener("DOMContentLoaded", function () {
    let cFUS3Tl1 = gsap.timeline({ paused: true });
    cFUS3Tl1.to('.co-fu-s3-map', {
        opacity: 1,
        duration: 1,
        delay: 0.5,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-fu-s3',
        start: "40% bottom",
        end: "bottom top",
        animation: cFUS3Tl1
    });
});